var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditor = function SvgEditor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.16 6.16a8.955 8.955 0 0 1 1.562-1.438M17 19.482a8.992 8.992 0 0 1-7.62 1.128M6.349 19a9.011 9.011 0 0 1-2.826-4M3.523 9A8.956 8.956 0 0 0 3 12M19.463 17A8.913 8.913 0 0 0 21 12a9 9 0 0 0-9-9M13.768 7.732a2.501 2.501 0 1 1-3.538 3.536 2.501 2.501 0 0 1 3.538-3.536M16.5 16a2.383 2.383 0 0 0-.594-.866v0a2.367 2.367 0 0 0-1.614-.634H9.708c-.6 0-1.174.227-1.614.634v0c-.26.241-.463.537-.594.866"
  })));
};
export { SvgEditor as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNThiZTFjNDZiZjU0OTViY2NhOWZiYjY2MTU0MjAxMDcuc3ZnIjs=";